import { useEffect, useRef } from 'react';
import {useLocation, matchPath, useHistory} from 'react-router';
import {useSelector} from 'react-redux';

import { showModal, hideModal } from '@utils/modal';
import {refetchQueryByName} from '@utils/apollo';

export function useModalRouting({
    routesMap,
    shouldHandleModal = true,
    indexUrl = null,
    queryToRefetch = [],
}) {
    const history = useHistory();
    const isModalVisible = useSelector(state => state.modal.isVisible);
    const wasModalVisible = useRef(false);
    const location = useLocation();
    const currentPath = location.pathname;
    const queryToRefetchRef = useRef(queryToRefetch);
    queryToRefetchRef.current = queryToRefetch;
    const routesMapRef = useRef(routesMap);
    routesMapRef.current = routesMap;

    useEffect(() => {
        if (!shouldHandleModal) return;

        const modalEntry = routesMapRef.current.find(route =>
            Array.isArray(route.path)
                ? route.path.some(p => matchPath(currentPath, { path: p, exact: true }))
                : matchPath(currentPath, { path: route.path, exact: true })
        );

        if (modalEntry) {
            showModal({
                header: modalEntry.header ?? false,
                isVisible: true,
                onClose: (e) => {
                    if (indexUrl && e && 'Escape' === e.key) {
                        history.push(indexUrl);
                    }
                },
                content: modalEntry.render(),
                size: modalEntry.size || 'small',
            });
        }
    }, [currentPath, shouldHandleModal, indexUrl, history]);

    useEffect(() => {
        if (!shouldHandleModal) return;

        if (!isModalVisible && wasModalVisible.current) {
            hideModal();

            queryToRefetchRef.current.forEach(query => {
                refetchQueryByName(query);
            });

            if (indexUrl) {
                history.push(indexUrl);
            }
        }

        wasModalVisible.current = isModalVisible;
    }, [isModalVisible, shouldHandleModal]);
}
